import axios from "axios";

export default class SimulationService {
  simulationFusion = async (data) => {
    try {
      const response = axios.post(
        `${process.env.REACT_APP_API_URL}/simulation-fusion/fusion`,
        data
      );
      return response;
    } catch (error) {
      throw new Error("Erreur lors de calcule: " + error.message);
    }
  };
  simulationUK = async (data) => {
    try {
      const response = axios.post(
        `${process.env.REACT_APP_API_URL}/simulation-uk`,
        data
      );
      return response;
    } catch (error) {
      throw new Error("Erreur lors de calcule: " + error.message);
    }
  };
  simulationLux = async (data) => {
    try {
      const response = axios.post(
        `${process.env.REACT_APP_API_URL}/simulation-lux`,
        data
      );
      return response;
    } catch (error) {
      throw new Error("Erreur lors de calcule: " + error.message);
    }
  };
  simulationSave = async (data) => {
    try {
      const response = axios.post(
        `${process.env.REACT_APP_API_URL}/simulations`,
        data
      );
      return response;
    } catch (error) {
      throw new Error("Erreur lors de calcule: " + error.message);
    }
  };

  contactCreate = async (data) => {
    try {
      const response = axios.post(
        `${process.env.REACT_APP_API_URL}/contact-forms`,
        data
      );
      return response;
    } catch (error) {
      throw new Error("Erreur lors de calcule: " + error.message);
    }
  };
}
export async function login(email = "", password = "") {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/users/loginConsulteck`,
      {
        email,
        password,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true, // ✅ Necessary for cross-subdomain cookies
      }
    );

    const userData = response.data;
    localStorage.setItem("userLoginRequestID", userData?.userId);
    return { success: true, msg: "Connexion réussie", userData };
  } catch (error) {
    if (error.response?.data) {
      console.error("API Error:", error.response.data);
      const { data } = error.response;

      return {
        success: false,
        msg: data.message,
      };
    } else {
      console.error("Login service error:", error.message);
      return {
        success: false,
        msg: "Une erreur s'est produite lors de la tentative de connexion",
      };
    }
  }
}
